(() => {
 const root = window.Shopify?.routes?.root || '/';
 const endpoint = path => root.replace(/\/$/,'') + path;
 async function update() {
   const container=document.querySelector('[data-fiole-cart-extras]');
   if(!container)return;
   try {
     const res=await fetch(endpoint('/cart.js'),{credentials:'same-origin'});
     if(!res.ok)throw new Error('Cart fetch failed');
     const cart=await res.json();
     const ids=new Set(cart.items.map(x=>x.variant_id));
     const message=container.querySelector('[data-fiole-shipping-message]');
     if(message){
       const remaining=Math.max(0,4500-cart.total_price);
       const fr=(container.dataset.locale||'').startsWith('fr');
       const amount=new Intl.NumberFormat(fr?'fr-CA':'en-CA',{style:'currency',currency:'CAD'}).format(remaining/100);
       const text=remaining>0?(fr?`Plus que ${amount} pour la livraison gratuite au Canada !`:`${amount} away from free shipping in Canada!`):(fr?'Félicitations ! Livraison gratuite débloquée !':'Free shipping unlocked!');
       if(message.textContent!==text)message.textContent=text;
       const track=container.querySelector('[role="progressbar"]');
       const progress=Math.min(100,cart.total_price/45);
       track?.setAttribute('aria-valuenow',String(Math.round(progress)));
       if(track?.firstElementChild)track.firstElementChild.style.width=`${progress}%`;
     }
     container.querySelectorAll('[data-fiole-upsell-add]').forEach(button=>{button.hidden=ids.has(Number(button.dataset.fioleUpsellAdd));});
   }catch(err){console.warn('FIOLE cart update:',err);}
 }
 document.addEventListener('click',async e=>{
   const button=e.target.closest('[data-fiole-upsell-add]');
   if(!button)return;
   button.disabled=true;
   try{
     const r=await fetch(endpoint('/cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.fioleUpsellAdd),quantity:1}]})});
     if(!r.ok)throw new Error((await r.json()).description||'Unable to add');
     const cart=await fetch(endpoint('/cart.js')).then(r=>r.json());
     // Refresh Dawn cart drawer through Shopify's section-rendering endpoint.
     const html=await fetch(endpoint('/?sections=cart-drawer')).then(r=>r.json());
     const doc=new DOMParser().parseFromString(html['cart-drawer']||'','text/html');
     const current=document.querySelector('cart-drawer');
     const replacement=doc.querySelector('cart-drawer');
     if(current&&replacement){
       const content=current.querySelector('#CartDrawer');
       const next=replacement.querySelector('#CartDrawer');
       if(content&&next)content.innerHTML=next.innerHTML;
       current.classList.toggle('is-empty',cart.item_count===0);
       current.open?.();
     }
     document.dispatchEvent(new CustomEvent('fiole:cart-updated',{detail:cart}));
     update();
   }catch(err){alert(err.message||'Unable to add to cart');}finally{button.disabled=false;}
 });
 document.addEventListener('fiole:cart-updated',update);
 new MutationObserver(()=>{if(document.querySelector('[data-fiole-cart-extras]'))update();}).observe(document.body,{childList:true,subtree:false});
 document.addEventListener('DOMContentLoaded',()=>{update(); if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,update);});
})();
